export default "__VITE_ASSET__BvIQXGr3__"